import { CardAppointmentComponent } from '../../components/card-appointment/card-appointment.component';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import InstantBookingService from '../../services/instant-booking.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-appointments',
	templateUrl: './list-appointments.component.html',
	imports: [ CommonModule, CardAppointmentComponent, FormsModule ]
})
export class ListAppointmentsComponent implements OnInit, OnDestroy {
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	@Input() appointments: any | undefined;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		var currentAppointmentsLength = 0;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.appointments.length !== currentAppointmentsLength) {
				currentAppointmentsLength = this.vm.appointments.length;
				this.handleIBTimerInit();
			}
		}, 300);
	}
	
	ngOnDestroy() {
		this.handleIBTimerDestroy();
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	handleIBTimerInit() {
		this.handleIBTimerDestroy();
		var hasInstantRequests: any = this.vm.appointments.filter(
			(appointment) => { return typeof appointment.chatOnly !== 'undefined'; }
		).length > 0;
		if (!hasInstantRequests) return;
		
		this.handleIBTimerUpdate();
		this.vm.timerInterval = this.angularHelperService.createInterval(this.handleIBTimerUpdate, 1000);
	}
	
	handleIBTimerUpdate() {
		var currentDate: any = moment();
		this.vm.appointments.forEach((appointment) => {
			if (typeof appointment.chatOnly === 'undefined') return;
			this.instantBookingService.calculateTimeLeft(appointment, currentDate);
			appointment.timeLeftText = this.angularHelperService.trustAsHtml(
				this.angularFilterHelperService.translate('Services.Other.Calling_Expires')
					.replace('%s', '<span class="c-text c-text--bold c-text--s16">' + appointment.timeLeft + '</span>')
			);
		});
	}
	
	handleIBTimerDestroy() {
		if (this.vm.timerInterval) this.angularHelperService.cancelInterval(this.vm.timerInterval);
	}
	
}